/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC, type JSX } from "react";

import LazyLoadResponsiveComponent from "../../../../components/LazyLoadResponsiveComponent/LazyLoadResponsiveComponent";
import { useThemeBackgroundColor } from "../../../../hooks/useThemeBackgroundColor";

const UserAccountScreen: FC = (): JSX.Element | undefined => {
  useThemeBackgroundColor((theme) => theme.colors.shade0);

  return (
    <LazyLoadResponsiveComponent
      mobileComponent={() => import("./containers/UserAccountMobile")}
      webComponent={() => import("./containers/UserAccountWeb")}
    />
  );
};

export default UserAccountScreen;
